export type IBindings = IDCA.IGenericFunc;

export function bindings() {
  // Initiate tooltips
  $('.tooltips').tooltip({ container: 'body' });
  // Initiate popovers
  $('.popovers').popover();
}
